<!--
* @description  参数1
* @fileName  CreatSuccessDialog
* @author userName
* @date 2023-12-27 15:06:29
!-->
<template>
  <div id="CreatSuccessDialog" class="CreatSuccessDialog">
    
     <global-login-dialog v-model="$store.state.user.createSuccessVisible" @close="closeDialog">
     <template v-slot:body>
        <slot name="successCreate">
        </slot>
        <slot name="successLogin">
        </slot>
        <!-- <img src="../../assets/img/client/login/pic_email.png" width="300px" height="200px">
        <p class="boldFont">Welcome to DTMS!</p>
        <div class="grayFont">You're just one step away from seamless freight comparison</div>
        <div class="grayFont margin8">Please check kehu@email.com to verify your account.</div>
        <div class="blueFont">Resend email</div> -->
     </template>
     </global-login-dialog>
  </div>
</template>

<script>
import GlobalLoginDialog from "../../components/Dialog/Dialog.vue";
export default {
  props: {
    // 父辈向子辈传参
  },
  name: "CreatSuccessDialog",
  data() {
    return {};
  },
  created() {
    // 实例被创建之后执行代码
  },
  computed: {
    // 计算属性
  },
  components: {
    // 组件的引用
    GlobalLoginDialog
  },
  methods: {
    // 方法
    closeDialog(){
        this.$store.commit("user/SUCCESS_VISIBLE", false);
    }
  },
  mounted() {
    // 页面进入时加载内容
    
  },
  watch: {
    // 监测变化
  },
};
</script>
<style scoped lang='scss'>
.CreatSuccessDialog{
    ::v-deep .dialog {
        //display: flex;
        width: 456px;
        min-height: 384px;
        background: #FFFFFF;
        border-radius: 16px;
        padding: 0;
        box-shadow: none;
        //top: 50%;
        //margin-top: -188px;
        .dialog__header{
            border-bottom:0
        }
        .dialog__body{
            padding: 0;
            .boldFont{
                font-size: 20px;
                font-family: D-DINExp, D-DINExp;
                font-weight: bold;
                color: #333333;
            }
            .grayFont{
                font-size: 14px;
                font-family: D, D;
                font-weight: normal;
                color: #777777;

            }
            .margin8{
                margin: 8px 0;
            }
            .blueFont{
                font-size: 14px;
                font-family: D, D;
                font-weight: normal;
                color: #027FFC;
                padding-bottom: 24px;
            }
        }
    
    }
}
  
</style>